import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {LanguageMenuModuleFetchHandler} from "./language-menu-module.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {LanguageMenuModuleHeaderClickHandler} from "./language-menu-module.header-click.handler";
import {LanguageMenuModuleItemClickHandler} from "./language-menu-module.item-click.handler";

export class LanguageMenuModuleHandlers extends HandlerList {

  static injectables = [
    LanguageMenuModuleFetchHandler,
    LanguageMenuModuleHeaderClickHandler,
    LanguageMenuModuleItemClickHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    languageMenuModuleFetchHandler: LanguageMenuModuleFetchHandler,
    languageMenuModuleHeaderClickHandler: LanguageMenuModuleHeaderClickHandler,
    languageMenuModuleItemClickHandler: LanguageMenuModuleItemClickHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      languageMenuModuleFetchHandler,
      languageMenuModuleHeaderClickHandler,
      languageMenuModuleItemClickHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}